import React from "react";
import { Animated, Platform, Text, TouchableOpacity, View } from "react-native";
import tw from "twrnc";

export default class ToggleSwitch extends React.Component {
  static defaultProps = {
    isOn: false,
    onColor: "#f4553b",
    offColor: "#e8e8e8",
    size: "medium",
    labelStyle: {},
    thumbOnStyle: {},
    thumbOffStyle: {},
    trackOnStyle: {},
    trackOffStyle: {},
    icon: null,
    disabled: false,
    animationSpeed: 300,
    useNativeDriver: true,
    circleColor: "white",
  };

  offsetX = new Animated.Value(0);
  dimensions = {
    width: 46,
    padding: 12,
    circleWidth: 18,
    circleHeight: 18,
    translateX: 26,
  };

  createToggleSwitchStyle = () => [
    tw`justify-center w-[46px] rounded-[20px] p-[12px]`,
    {
      backgroundColor: this.props.isOn
        ? this.props.onColor
        : this.props.offColor,
    },
    this.props.isOn ? this.props.trackOnStyle : this.props.trackOffStyle,
  ];

  createInsideCircleStyle = () => [
    tw`items-center justify-center absolute bg-white w-[18px] h-[18px] rounded-full shadow`,
    {
      margin: Platform.OS === "web" ? 0 : 4,
      left: Platform.OS === "web" ? 4 : 0,
      backgroundColor: this.props.circleColor,
      transform: [{ translateX: this.offsetX }],
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.2,
      shadowRadius: 2.5,
      elevation: 1.5,
    },
    this.props.isOn ? this.props.thumbOnStyle : this.props.thumbOffStyle,
  ];

  render() {
    const { isOn, onToggle, disabled, labelStyle, label, icon } = this.props;

    const toValue = isOn
      ? this.dimensions.width - this.dimensions.translateX
      : 0;

    Animated.timing(this.offsetX, {
      toValue,
      duration: this.props.animationSpeed,
      useNativeDriver: this.props.useNativeDriver,
    }).start();

    return (
      <View style={tw`flex-row items-center`}>
        {label ? <Text style={[tw`mx-2.5`, labelStyle]}>{label}</Text> : null}
        <TouchableOpacity
          style={this.createToggleSwitchStyle()}
          activeOpacity={0.8}
          onPress={() => (disabled ? null : onToggle(!isOn))}
        >
          <Animated.View style={this.createInsideCircleStyle()}>
            {icon}
          </Animated.View>
        </TouchableOpacity>
      </View>
    );
  }
}
